'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { SectionHeader } from './SectionHeader'
import { menuPhotoUrl } from '@/lib/utils/imageTransform'

/**
 * Galería del LOCAL: el salón, la barra, el equipo, la parrilla encendida.
 *
 * Distinta del carrusel de "Sobre nosotros", que muestra fotos de PLATILLOS
 * sacadas del menú. Acá el merchant enseña el lugar — que es lo que decide si
 * alguien viene a sentarse.
 *
 * Mosaico vertical (columnas CSS) y no rejilla fija: las fotos de un local
 * vienen en cualquier proporción —una barra apaisada, un plato cuadrado, el
 * equipo en vertical— y recortarlas todas al mismo cuadro es justo lo que las
 * hace ver de catálogo. Así cada una conserva la suya.
 */
export function GallerySection({ images }: { images: string[] }) {
  // Resuelve su propio texto, como el resto de las secciones del microsite:
  // RestaurantMicrosite no tiene traductor y pasárselo desde ahí obligaría a
  // agregárselo solo para esto.
  const t = useTranslations('public.microsite')
  if (!images.length) return null

  return (
    <section
      id="gallery"
      className="scroll-mt-20 px-5 sm:px-8 py-14 sm:py-20 max-w-6xl mx-auto"
      style={{ background: 'var(--ms-bg)' }}
    >
      <SectionHeader number="" kicker={t('galleryKicker')} title={t('galleryTitle')} />

      <div
        className="mt-8 [column-fill:_balance]"
        style={{ columnCount: 2, columnGap: '12px' }}
      >
        {images.slice(0, 12).map((url, i) => (
          <div
            key={`${url}-${i}`}
            className="mb-3 overflow-hidden break-inside-avoid"
            style={{
              borderRadius: 'var(--ms-radius)',
              border: '1px solid var(--ms-border)',
              boxShadow: 'var(--ms-card-shadow)',
            }}
          >
            <Image
              src={menuPhotoUrl(url, 800)}
              alt=""
              width={800}
              height={0}
              sizes="(max-width: 640px) 50vw, 33vw"
              className="h-auto w-full object-cover transition duration-500 hover:scale-[1.03]"
              style={{ display: 'block' }}
            />
          </div>
        ))}
      </div>

      {/* Tres columnas desde sm: en el teléfono dos ya dan fotos legibles y
          tres las dejarían del tamaño de una miniatura. */}
      <style jsx>{`
        @media (min-width: 640px) {
          div[style*='column-count'] {
            column-count: 3;
          }
        }
      `}</style>
    </section>
  )
}
